import { useEffect, useState } from "react";
import FileAPI from "../apis/FileAPI";

const useImages = (arr) => {
  const [images, setImages] = useState({});

  useEffect(() => {
    if (!arr) return;

    const pushUrlImage = (image) => {
      if (
        images[image] ||
        image === null ||
        image === undefined ||
        image === ""
      )
        return;
      images[image] = false;
      FileAPI.getUrlImage(image).then((url) =>
        setImages((state) => ({ ...state, [image]: url }))
      );
    };

    arr.map((image) => {
      pushUrlImage(image);
    });
  }, [arr]);

  return images;
};

export { useImages };
